import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';
import { GanttChart } from 'components/widgets/Gantt/GanttChart';
import { GanttChartCardModel } from 'components/widgets/Gantt/components/ganttChartCardModel';

export const GanttPage = () => {
    useFullStoryPageView({ pageName: executionConfig.ganttChart.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader>
                    <ShareInsightButton title={executionConfig.ganttChart.title} link={window.location.href} />
                    <GlobalFilterButton />
                </TreeProgramTopHeader>

                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.ganttChart.title} />
                    <GlobalFilterComponent
                        defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                    >
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <GanttChart />
                </PageWidgetWrapper>
            </MainContent>
            <GanttChartCardModel />
        </PageContainer>
    );
};
